import React, { useState } from 'react';
import Alert from 'react-s-alert';
import { cloneDeep } from 'lodash';
import logo from '../../images/zaddons_logo.png'
import WorkplanManager from '../../../WorkplanManager/components/App';
import SingleLayout from '../Layout/SingleLayout.js';
import { translate } from 'react-i18next';
import AdminSettings from '../../../AdminSettings';
import NotFound from '../NotFound';
import urlHelper from '../../utilities/urlHelper.js';
import LoginForm from './LoginForm';
import AuthService, { Toast } from '../../../services/auth';

const hasQueryStringParams = window.location.href.indexOf('?') !== -1;
const appTargetFromSession = sessionStorage.getItem('appTarget');
const target = hasQueryStringParams
    ? urlHelper.getQueryStringParam(window.location.href, 'target')
    : appTargetFromSession;

const ssoToken = hasQueryStringParams
    ? urlHelper.getQueryStringParam(window.location.href, 'ssoToken')
    : undefined;

const ADMIN_SETTINGS = 'adminSettings';
const MANAGER_PORTAL = 'workplanManager';
const WORKPLANMANAGER_APPLICATIONS = [ADMIN_SETTINGS, MANAGER_PORTAL];

/**
 * @param {{ password: string; username: string; }} param0
 * @returns {boolean} `true` when no error messages in the login form
 */
export const validateFormLogin = ({ password, username }) => {
    var errorMessage = '';

    if (password !== null && !password.trim()) {
        errorMessage = 'Password is required';
    }

    if (username !== null && !username.trim()) {
        errorMessage = 'Username is required';
    }

    if (errorMessage) {
        Toast.fire({
            type: 'error',
            title: errorMessage,
            timer: 3000
        });
    }

    return !errorMessage;
};

const emptyAccount = {
    username: "",
    password: "",
};
const Login = ({ children }) => {
    const [account, setAccount] = useState({ ...emptyAccount });

    const handleChange = ({ currentTarget: { name, value } }) => {
        const updatedAccount = cloneDeep(account);
        updatedAccount[name] = value;
        setAccount(updatedAccount);
    }

    const handleSubmitLogin = (event) => {
        event.preventDefault();

        if (validateFormLogin(account)) {
            AuthService.login(account.username, account.password, target)
                .then(success => {
                    if (success) {
                        window.history.replaceState({}, '', `${window.location.pathname}`);
                        setAccount({ ...emptyAccount });
                    }
                });
        }
    }
    const redirectLogin = () => {
        AuthService.logout();
    };
    if (!WORKPLANMANAGER_APPLICATIONS.includes(target)) {
        return <NotFound />;
    }

    if (!AuthService.isLoggedIn()) {
        if (!ssoToken) {
            return (
                <>
                    <Alert stack={{ limit: 3 }} />
                    <LoginForm
                        account={account}
                        children={children}
                        logo={logo}
                        handleChange={handleChange}
                        handleSubmitLogin={handleSubmitLogin}
                    />
                </>
            );
        }

        AuthService.ssoLogin(ssoToken, target)
            .then(success => {
                if (success) {
                    window.history.replaceState({}, '', `${window.location.pathname}`);
                    setAccount({ ...emptyAccount });
                }
            });
        return <></>;
    }

    switch (target) {
        case ADMIN_SETTINGS:
            return (
                <SingleLayout
                    component={<AdminSettings />}
                    redirectLogin={redirectLogin}
                    refreshSession={AuthService.refreshToken}
                />
            );
        case MANAGER_PORTAL:
            return (
                <SingleLayout
                    component={<WorkplanManager refreshAdmin={AuthService.refreshToken} />}
                    redirectLogin={redirectLogin}
                    refreshSession={AuthService.refreshToken}
                />
            );
        default:
            return <NotFound />;
    }
}

export default translate('common')(Login);